import { render } from "./SignedBarWithValue.vue?vue&type=template&id=1f944f98&scoped=true"
import script from "./SignedBarWithValue.vue?vue&type=script&lang=js"
export * from "./SignedBarWithValue.vue?vue&type=script&lang=js"

import "./SignedBarWithValue.vue?vue&type=style&index=0&id=1f944f98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f944f98"]])

export default __exports__